exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Applies styles for users in high contrast mode. Note that this only applies\n * to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n * attribute, however Chrome handles high contrast differently.\n */\n/* Theme for the ripple elements.*/\n/* stylelint-disable material/no-prefixes */\n/* stylelint-enable */\n:host {\n  width: 100%; }\n:host .bottomContent .add-todo-button {\n    width: 45%;\n    margin: 5px;\n    padding: 1px; }\n:host .bottomContent .p-7 {\n    padding: 7px !important; }\n:host .bottomContent .p-8.sideHeading {\n    text-align: center;\n    font-weight: 500;\n    font-size: x-large;\n    padding-bottom: 8px !important;\n    padding-top: 10px !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/bottom/bottom-sidenav.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/bottom/bottom-sidenav.component.scss
// module chunks = main